var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21849 0.205322C3.49315 -0.069519 3.93828 -0.0693359 4.21275 0.205322L7.2252 3.21777C7.49986 3.49225 7.49986 3.93756 7.2252 4.21204C6.95073 4.48669 6.5056 4.48669 6.23094 4.21204L4.41875 2.39984V7.48047C4.41875 7.86884 4.10381 8.18359 3.71562 8.18359C3.32725 8.18359 3.0125 7.86884 3.0125 7.48047V2.39984L1.2003 4.21204C0.925644 4.48669 0.480514 4.48669 0.205856 4.21204C-0.0686188 3.93756 -0.0686188 3.49225 0.205856 3.21777L3.21849 0.205322Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72821 9.79102H0.703125C0.314941 9.79102 0 10.1058 0 10.4941C0 10.8823 0.314941 11.1973 0.703125 11.1973H6.72821C7.11639 11.1973 7.43134 10.8823 7.43134 10.4941C7.43134 10.1058 7.11658 9.79102 6.72821 9.79102Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpload);
export default __webpack_public_path__ + "static/media/arrow-upload.19b9505485a3bc44a89634baf35517b1.svg";
export { ForwardRef as ReactComponent };